module.exports = __webpack_public_path__ + "static/img/thaiqr_banner.b72479f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaiqr_banner.png
// module id = 672
// module chunks = 1